import React, { Component, Fragment } from "react";
import classNames from "classnames";
import compose from "recompose/compose";
import PropTypes from "prop-types";

import { useMediaQuery, useTheme, Drawer } from '@mui/material';
import { withStyles } from '@mui/styles';

import { Sidebar, Topbar, Footer } from "./components";
import styles from "./styles";
import { IsValidSessionSwitch, GetStateStorage } from "common/storage";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    const isMobile = ["xs", "sm", "md"].includes(props.width || 'lg');

    this.state = {
      isOpen: !isMobile,
      sessionSwitchMode: false,
      localStateData: {},
    };
  }

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  handleToggleOpen = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  componentDidMount() {
    /**check for switch session */
    let isValidSwitchSession = IsValidSessionSwitch();
    let localStateData = GetStateStorage();
    this.setState({
      sessionSwitchMode: isValidSwitchSession,
      localStateData: localStateData ? localStateData : {},
    });
  }

  render() {
    const { classes, width = 'lg', title, children, isCompleteInvisible } = this.props;
    const { isOpen, sessionSwitchMode, localStateData } = this.state;

    const isMobile = ["xs", "sm", "md"].includes(width);
    const shiftTopbar = isOpen && !isMobile;
    const shiftContent = isOpen && !isMobile;

    return !isCompleteInvisible ? (
      <Fragment>
        <Topbar
          className={classNames(classes.topbar, {
            [classes.topbarShift]: shiftTopbar,
          })}
          isSidebarOpen={isOpen}
          onToggleSidebar={this.handleToggleOpen}
          title={title}
          localStateData={localStateData}
          sessionSwitchMode={sessionSwitchMode}
        />
        <Drawer
          anchor="left"
          classes={{ paper: classes.drawerPaper }}
          onClose={this.handleClose}
          open={isOpen}
          ModalProps={isMobile ? {
            keepMounted: true,
            style: { zIndex: 3000 },
            BackdropProps: { style: { zIndex: 2999 } },
            container: typeof window !== 'undefined' ? document.body : undefined
          } : undefined}
          variant={isMobile ? "temporary" : "persistent"}
        >
          <Sidebar
            className={classes.sidebar}
            sessionSwitchMode={sessionSwitchMode}
          />
        </Drawer>
        <main
          className={classNames(classes.content, {
            [classes.contentShift]: shiftContent,
          })}
        >
          {children}
          <Footer />
        </main>
      </Fragment>
    ) : (
      <main>{children}</main>
    );
  }
}

Dashboard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  width: PropTypes.string,
  isCompleteInvisible: PropTypes.bool,
};

// defaultProps removed - class component

export default compose(withStyles(styles))(Dashboard);
